<template>
  <v-card>
    <v-toolbar class="fixed-toolbar" dark color="primary">
      <v-btn icon dark @click="resetEditCmr(null)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title v-if="isReadOnly && editCrmId">{{
        $t("crm.document_details")
      }}</v-toolbar-title>
      <v-toolbar-title v-else-if="editCrmId">{{
        $t("crm.edit")
      }}</v-toolbar-title>
      <v-toolbar-title v-else>{{ $t("crm.create_cmr") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="!isReadOnly">
        <v-btn dark text @click="saveCmr">{{ $t("crm.save") }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-container>
        <v-row>
          <v-col cols="12" sm="8">
            <v-row :key="forceUpdateKey">
              <v-col
                class="pb-0"
                cols="12"
                :class="{ 'order-edit-modal__readonly': isReadOnly }"
              >
                <template v-for="(item, i) in filtredFields">
                  <v-row
                    v-if="
                      item.cmrInput &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    no-gutters
                  >
                    <v-col cols="2" v-if="!setDisabled(item.disabled)">
                      <v-text-field
                        disabled
                        outlined
                        :value="cmrCodeFinalValue.collectionCountryCode"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" v-if="!setDisabled(item.disabled)">
                      <v-text-field
                        disabled
                        outlined
                        :value="cmrCodeFinalValue.senderOrganization"
                      ></v-text-field>
                    </v-col>
                    <v-col :cols="setDisabled(item.disabled) ? 12 : 6">
                      <v-text-field
                        :label="$t(item.t)"
                        :required="item.required"
                        :rules="[
                          required(item.required),
                          (value) => cmrCode(value, setDisabled(item.disabled)),
                        ]"
                        v-model="item.val"
                        minlength="6"
                        maxlength="20"
                        outlined
                        :disabled="setDisabled(item.disabled)"
                        :hint="$t('user.required')"
                        persistent-hint
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" v-if="!setDisabled(item.disabled)">
                      <v-text-field
                        disabled
                        outlined
                        :value="cmrCodeFinalValue.providerName"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-text-field
                    v-if="
                      (item.input || item.email) &&
                        (!isExtraEditing(isReadOnly) ||
                          isLicensePlatePdfField(item)) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    :label="$t(item.t)"
                    :required="item.required"
                    :rules="[required(item.required)]"
                    v-model="item.val"
                    :counter="Boolean(item.maxLength)"
                    :maxlength="item.maxLength"
                    outlined
                    :disabled="setDisabled(item.disabled)"
                    @change="onChangeSideEffects($event, item.name)"
                  ></v-text-field>
                  <v-textarea
                    v-if="
                      item.textarea &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    :label="$t(item.t)"
                    :required="item.required"
                    :rules="[required(item.required)]"
                    v-model="item.val"
                    :counter="Boolean(item.maxLength)"
                    :maxlength="item.maxLength"
                    outlined
                    auto-grow
                    rows="3"
                    :disabled="setDisabled(item.disabled)"
                    @change="onChangeSideEffects($event, item.name)"
                  ></v-textarea>
                  <v-checkbox
                    v-if="
                      item.checkbox &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    :label="$t(item.t)"
                    :required="item.required"
                    :rules="[required(item.required)]"
                    v-model="item.val"
                    outlined
                    :disabled="setDisabled(item.disabled)"
                    color="#5b8ff5"
                    class="my-0 py-0"
                  ></v-checkbox>
                  <v-dialog
                    v-if="
                      item.id === 41 &&
                        item.isTime &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    v-model="item.calendar"
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="item.val"
                        :label="$t(item.t)"
                        prepend-icon="mdi-calendar-month"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="setDisabled(item.disabled)"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :first-day-of-week="1"
                      v-model="item.val"
                      scrollable
                      :locale="$i18n.locale"
                      color="#5b8ff5"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="#5b8ff5"
                        @click="
                          item.calendar = false;
                          item.val = '';
                        "
                      >
                        {{ $t("clear") }}
                      </v-btn>
                      <v-btn
                        text
                        color="#5b8ff5"
                        @click="item.calendar = false"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-menu
                    v-if="
                      item.isDate &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    v-model="item.calendar"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :disabled="setDisabled(item.disabled)"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="item.val"
                        :label="$t(item.t)"
                        prepend-icon="mdi-calendar-month"
                        readonly
                        v-on="on"
                        :required="item.required"
                        :rules="[required(item.required)]"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="item.val"
                      no-title
                      scrollable
                      color="primary"
                      header-color="primary"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="cancelDatePicker(i)">
                        {{ $t("cancel") }}
                      </v-btn>
                      <v-btn text color="primary" @click="closeDatePicker(i)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                  <v-datetime-picker
                    v-if="
                      item.id !== 41 &&
                        item.isTime &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    v-model="item.val"
                    :ref="item.name"
                    :label="$t(item.t)"
                    :textFieldProps="getInputProps(item)"
                    :datePickerProps="getDateProps()"
                    :timePickerProps="getTimeProps()"
                    :key="item.id"
                    dateFormat="yyyy-MM-dd"
                    timeFormat="HH:mm"
                    :disabled="setDisabled(item.disabled)"
                  >
                    <template slot="dateIcon">
                      <v-icon color="#5b8ff5">mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon color="#5b8ff5">mdi-clock</v-icon>
                    </template>
                  </v-datetime-picker>

                  <v-autocomplete
                    v-if="
                      ([3, 4].includes(cmrStatus) && item.id === 82) ||
                        (item.autocomplete &&
                          !isExtraEditing(isReadOnly) &&
                          isShowInCreating(item.isShowInCreat))
                    "
                    :key="item.id"
                    v-model="item.val"
                    :items="
                      isOrgField(item)
                        ? getOrgItems(item.name)
                        : getList(item.items)
                    "
                    item-text="name"
                    item-value="id"
                    :label="$t(item.t)"
                    outlined
                    clearable
                    :required="item.required"
                    :rules="[required(item.required)]"
                    :disabled="setDisabled(item.disabled)"
                    @change="handlerOrganization($event, item)"
                    :no-data-text="$t('noDataAvailable')"
                    :hint="item.required ? $t('user.required') : ''"
                    :persistent-hint="item.required"
                    :loading="
                      isOrgField(item) ? getOrgLoading(item.name) : false
                    "
                    :search-input.sync="orgSearch[item.name]"
                    :filter="isOrgField(item) ? orgNoFilter : undefined"
                    @focus="isOrgField(item) && onOrgOpen(item.name)"
                    @click="isOrgField(item) && onOrgOpen(item.name)"
                    @update:search-input="
                      isOrgField(item) && onOrgSearchInput(item.name, $event)
                    "
                    @click:clear="isOrgField(item) && onOrgClear(item.name)"
                  >
                    <template v-slot:item="data">
                      <div>
                        <div>
                          <b>{{ data.item.name }}</b>
                        </div>
                        <div>
                          <span v-if="data.item.street">{{
                            data.item.street
                          }}</span>
                          <span v-if="data.item.postalCode"
                            >, {{ data.item.postalCode }}</span
                          >
                          <span v-if="data.item.place"
                            >, {{ data.item.place }}</span
                          >
                          <span v-if="data.item.countryCode"
                            >, {{ data.item.countryCode }}</span
                          >
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>

                  <v-autocomplete
                    v-if="
                      item.countries &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    v-model="item.val"
                    :items="getList(item.items)"
                    :item-text="(data) => data.name + ' - ' + data.code"
                    item-value="code"
                    :label="$t(item.t)"
                    outlined
                    :required="item.required"
                    :rules="[required(item.required)]"
                    :disabled="setDisabled(item.disabled)"
                    :no-data-text="$t('noDataAvailable')"
                  ></v-autocomplete>

                  <v-select
                    v-if="
                      item.select &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    v-model="item.val"
                    :items="getList(item.items)"
                    item-text="text"
                    item-value="value"
                    :label="$t(item.t)"
                    outlined
                    :disabled="setDisabled(item.disabled)"
                  ></v-select>

                  <template
                    v-if="
                      item.divider &&
                        item.hasAdd &&
                        (!isExtraEditing(isReadOnly) ||
                          item.name === 'returnedGoods') &&
                        isShowInCreating(item.isShowInCreat)
                    "
                  >
                    <v-subheader
                      class="cmr-details__title justify-space-between"
                      :key="item.id + 'a'"
                    >
                      {{ $t(item.t) }}
                      <div class="order-edit-modal__anchor">
                        <div :id="item.name"></div>
                      </div>
                      <v-tooltip bottom v-if="!isReadOnly">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="btn-two--add mobile-block mr-0"
                            text
                            @click.stop="() => openDialogTable(item.name)"
                            v-on="on"
                          >
                            <v-icon medium>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ getTooltip(item.name) }}</span>
                      </v-tooltip>
                    </v-subheader>
                    <v-divider :key="item.id + 'b'" class="mb-8"></v-divider>
                  </template>

                  <template
                    v-if="
                      item.divider &&
                        !item.hasAdd &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                  >
                    <v-subheader
                      class="cmr-details__title justify-space-between"
                      :key="item.id + 'a'"
                    >
                      {{ $t(item.t) }}
                      {{
                        item.id === 100
                          ? cmrCodeFinalValue.getValue() === "VAE"
                            ? ""
                            : cmrCodeFinalValue.getValue()
                          : ""
                      }}
                      <div class="order-edit-modal__anchor">
                        <div :id="item.name"></div>
                      </div>
                    </v-subheader>
                    <v-divider :key="item.id + 'b'" class="mb-8"></v-divider>
                  </template>

                  <span
                    v-if="
                      item.checkboxValue &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                  >
                    <CheckBoxInput
                      v-model="item.val"
                      :item="item"
                      :is-read-only="isReadOnly"
                    ></CheckBoxInput>
                  </span>

                  <v-divider
                    v-if="
                      item.dividerLow &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    class="mb-8"
                  ></v-divider>

                  <div
                    v-if="
                      item.img &&
                        item.val !== '' &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    class="mb-8"
                  >
                    <v-label>{{ $t(item.t) }}</v-label>
                    <img :src="signatureImg(item.val)" alt="" />
                  </div>

                  <div
                    v-if="item.table && item.name === 'pallets'"
                    :key="item.id"
                    class="mb-8"
                  >
                    <OrdersEditModalTables
                      :cmr="cmr"
                      :edit-crm-id="editCrmId"
                      :table-type="item.name"
                      :dialog="dialogTable"
                      :dialog-goods="dialogTableGoods"
                      :dialog-containers="dialogTableContainers"
                      :on-list-change="updateFromEditModalDialog"
                      :close-dialog-table="() => closeDialogTable(item.name)"
                      :open-dialog-table="() => openDialogTable(item.name)"
                      :is-read-only="isReadOnly"
                      :cmr-status="cmrStatus"
                    ></OrdersEditModalTables>
                  </div>

                  <div
                    v-if="
                      item.table &&
                        item.name !== 'pallets' &&
                        !isExtraEditing(isReadOnly)
                    "
                    :key="item.id"
                    class="mb-8"
                  >
                    <OrdersEditModalTables
                      :cmr="cmr"
                      :edit-crm-id="editCrmId"
                      :table-type="item.name"
                      :dialog="dialogTable"
                      :dialog-goods="dialogTableGoods"
                      :dialog-containers="dialogTableContainers"
                      :on-list-change="updateFromEditModalDialog"
                      :close-dialog-table="() => closeDialogTable(item.name)"
                      :open-dialog-table="() => openDialogTable(item.name)"
                      :is-read-only="isReadOnly"
                      :cmr-status="cmrStatus"
                    ></OrdersEditModalTables>
                  </div>

                  <div
                    v-if="
                      item.isSignatureMethod &&
                        item.val !== 'No comments' &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    class="mb-8"
                  >
                    <v-label>{{ $t(item.t) }}</v-label>
                    <p>{{ item.val }}</p>
                  </div>

                  <div
                    v-if="
                      item.text &&
                        item.val !== '' &&
                        item.val !== 'No comments' &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    class="mb-8"
                  >
                    <v-label>{{ $t(item.t) }}</v-label>
                    <p class="order-edit-modal__multiline-text">
                      {{
                        item.dateFormat ? dateFormatToUi(item.val) : item.val
                      }}
                    </p>
                  </div>

                  <div
                    v-if="
                      item.text &&
                        item.val === 'No comments' &&
                        !isExtraEditing(isReadOnly) &&
                        isShowInCreating(item.isShowInCreat)
                    "
                    :key="item.id"
                    class="mb-8"
                  >
                    <v-label>{{ $t("crm.noComments") }}</v-label>
                  </div>
                </template>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="4">
            <div
              class="order-edit-modal__nav-btn"
              :class="{ active: !navTrigger }"
            >
              <v-icon color="#5b8ff5" @click="navTrigger = true">
                mdi-menu-open
              </v-icon>
            </div>
            <v-card
              class="order-edit-modal__nav-fixed"
              :class="{ active: navTrigger }"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    {{ $t("navigate") }}
                  </v-list-item-title>
                  <v-icon color="#5b8ff5" @click="navTrigger = false">
                    mdi-close
                  </v-icon>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list v-if="!isExtraEditing(isReadOnly)" dense nav>
                <v-list-item
                  v-for="item in navigateList"
                  :key="item.id"
                  link
                  :href="item.href"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ $t(item.name) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-card>
</template>

<script>
import config from "../../config";
import Axios from "axios";

import CheckBoxInput from "./CheckBoxInput";
import OrdersEditModalTables from "./OrdersEditModalTables";
import { CMR_STATUSES } from "@/constants/cmr";
import cleanObject from "@/utils/cleanObject";

export default {
  components: { CheckBoxInput, OrdersEditModalTables },
  name: "OrdersEditModal",
  props: ["editCrmId", "editDialog", "closeDialog", "isReadOnly", "reloadCmr"],
  data() {
    return {
      defaultCmr: {
        senderOrganizationsID: null,
        recipientOrganizationsID: null,
        carrierOrganizationsID: null,
        cmrCode: null,
        loadOrderID: null,
        unLoadOrderID: null,
        deliveryStreet: null,
        deliveryPostalCode: null,
        deliveryPlace: null,
        deliveryCountryCode: null,
        collectionStreet: null,
        collectionPostalCode: null,
        collectionPlace: null,
        collectionCountryCode: null,
        senderInstructions: null,
        franco: null,
        carrierReservations: null,
        specialAgreements: null,
        drawnUpPlace: null,
        drawnUpDate: null,
        transportType: null,
        LadingCodeBill: null,
        collectionDate: null,
        deliveryDate: null,
        receptionExpectedTime: null,
        estimatedDeliveryTime: null,
        senderEmail: null,
        carrierEmail: null,
        receiverEmail: null,
        driverEmail: null,
        successiveCarriersList: null,
        cashOnDelivery: null,
        driverName: null,
        cmrTypeValue: null,
        escalateCommentSenderEmail: null,
        escalateCommentCarrierEmail: null,
        escalateCommentRecipientEmail: null,
        tripID: null,
        senderSupportEmail: null,
        carrierSupportEmail: null,
        recipientSupportEmail: null,
        excessReceptionValue: null,
        excessDeliveryValue: null,
        LicensePlateNumberList: null,
        signatureReceiverDateTime: null,
        signatureShipperDateTime: null,
        signatureDriverDateTime: null,
        licenseplateTruckPDF: null,
        licenseplateTrailerPDF: null,
      },
      orgSearch: {
        senderOrganizationsID: "",
        carrierOrganizationsID: "",
        recipientOrganizationsID: "",
      },

      orgDebounceTimer: {
        senderOrganizationsID: null,
        carrierOrganizationsID: null,
        recipientOrganizationsID: null,
      },
      orgItemsByField: {
        senderOrganizationsID: [],
        carrierOrganizationsID: [],
        recipientOrganizationsID: [],
      },
      orgTopByField: {
        senderOrganizationsID: [],
        carrierOrganizationsID: [],
        recipientOrganizationsID: [],
      },
      orgTopLoadedByField: {
        senderOrganizationsID: false,
        carrierOrganizationsID: false,
        recipientOrganizationsID: false,
      },
      orgCacheByField: {
        senderOrganizationsID: Object.create(null),
        carrierOrganizationsID: Object.create(null),
        recipientOrganizationsID: Object.create(null),
      },
      orgLoadingByField: {
        senderOrganizationsID: false,
        carrierOrganizationsID: false,
        recipientOrganizationsID: false,
      },

      cmr: {},
      cmrStatus: "",
      editFields: [
        // start
        {
          id: 100,
          name: "cmr",
          val: "",
          t: "crm.cmr",
          divider: true,
          isShowInCreat: true,
        },

        {
          id: 8,
          name: "cmrCode",
          val: "",
          t: "crm.cmrCode",
          required: false,
          cmrInput: true,
          disabled: true,
          isShowInCreat: true,
        },
        {
          id: 11,
          name: "status",
          val: "",
          t: "crm.status",
          required: false,
          items: "allStatus",
          select: true,
          disabled: true,
          isShowInCreat: false,
        },
        {
          id: 68,
          name: "type",
          val: "",
          t: "crm.type",
          required: false,
          items: "allTypes",
          autocomplete: true,
          isShowInCreat: true,
        },
        {
          id: 72,
          name: "tripID",
          val: "",
          t: "crm.tripID",
          required: false,
          input: true,
          disabled: true,
          isShowInCreat: true,
        },
        {
          id: 9,
          name: "loadOrderID",
          val: "",
          t: "crm.loadOrderID",
          required: false,
          input: true,
          isShowInCreat: false,
        },
        {
          id: 10,
          name: "unLoadOrderID",
          val: "",
          t: "crm.unLoadOrderID",
          required: false,
          input: true,
          isShowInCreat: false,
        },

        { id: 106, dividerLow: true, isShowInCreat: true },

        {
          id: 5,
          name: "senderOrganizationsID",
          senderOrganizationName: "",
          val: "",
          t: "crm.senderOrganizationsID",
          items: "allOrganizations",
          required: true,
          autocomplete: true,
          isShowInCreat: true,
        },
        {
          id: 7,
          name: "carrierOrganizationsID",
          val: "",
          t: "crm.carrierOrganizationsID",
          items: "allOrganizations",
          required: false,
          autocomplete: true,
          addEvent: true,
          isShowInCreat: true,
        },
        {
          id: 6,
          name: "recipientOrganizationsID",
          val: "",
          t: "crm.recipientOrganizationsID",
          items: "allOrganizations",
          required: false,
          autocomplete: true,
          isShowInCreat: true,
        },
        {
          id: 83,
          name: "customerCompanySign",
          val: "",
          t: "crm.customerCompanySign",
          required: false,
          items: "allCustomerCompanySign",
          autocomplete: true,
          isShowInCreat: true,
        },

        { id: 107, dividerLow: true, isShowInCreat: true },

        {
          id: 82,
          name: "driverUserName",
          val: "",
          t: "crm.driver",
          items: "allDrivers",
          required: false,
          autocomplete: true,
          isShowInCreat: true,
        },
        {
          id: 213,
          name: "licenseplateTruckPDF",
          val: "",
          t: "crm.licenseplateTruckPDF",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 214,
          name: "licenseplateTrailerPDF",
          val: "",
          t: "crm.licenseplateTrailerPDF",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 116,
          name: "goods",
          val: "",
          t: "crm.goods",
          divider: true,
          hasAdd: true,
          isShowInCreat: true,
        },
        {
          id: 85,
          name: "goods",
          val: "",
          t: "crm.goods",
          required: false,
          table: true,
          isShowInCreat: true,
        },

        {
          id: 117,
          name: "returnedGoods",
          val: "",
          t: "crm.returned_goods",
          divider: true,
          hasAdd: true,
          isShowInCreat: true,
        },
        {
          id: 86,
          name: "returnedGoods",
          val: "",
          t: "crm.returned_goods",
          required: false,
          table: true,
          isShowInCreat: true,
        },
        {
          id: 121,
          name: "pallets",
          val: "",
          t: "crm.pallets",
          required: false,
          table: true,
          isShowInCreat: true,
        },

        {
          id: 118,
          name: "containers",
          val: "",
          t: "crm.containers",
          divider: true,
          hasAdd: true,
          isShowInCreat: true,
        },
        {
          id: 87,
          name: "containers",
          val: "",
          t: "crm.containers",
          required: false,
          table: true,
          isShowInCreat: true,
        },

        // DEPOSE CONTAINER
        {
          id: 200,
          name: "deposeContainerAddress",
          val: "",
          t: "crm.deposeContainerAddress",
          divider: true,
          isShowInCreat: true,
        },

        {
          id: 201,
          name: "deposeContainerPostalCode",
          val: "",
          t: "crm.deposeContainerPostalCode",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 202,
          name: "deposeContainerPlace",
          val: "",
          t: "crm.deposeContainerPlace",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 203,
          name: "deposeContainerStreet",
          val: "",
          t: "crm.deposeContainerStreet",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 204,
          name: "deposeContainerCountryCode",
          val: "",
          t: "crm.deposeContainerCountryCode",
          required: false,
          items: "allCountries",
          countries: true,
          isShowInCreat: true,
        },

        // PICKUP CONTAINER
        {
          id: 205,
          name: "pickupContainerAddress",
          val: "",
          t: "crm.pickupContainerAddress",
          divider: true,
          isShowInCreat: true,
        },

        {
          id: 206,
          name: "pickupContainerPostalCode",
          val: "",
          t: "crm.pickupContainerPostalCode",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 207,
          name: "pickupContainerPlace",
          val: "",
          t: "crm.pickupContainerPlace",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 208,
          name: "pickupContainerStreet",
          val: "",
          t: "crm.pickupContainerStreet",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 209,
          name: "pickupContainerCountryCode",
          val: "",
          t: "crm.pickupContainerCountryCode",
          required: false,
          items: "allCountries",
          countries: true,
          isShowInCreat: true,
        },

        // COLLECTION ADDRESS
        {
          id: 105,
          name: "collection",
          val: "",
          t: "crm.collection",
          divider: true,
          isShowInCreat: true,
        },

        {
          id: 210,
          name: "collectionName",
          val: "",
          t: "crm.collectionName",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 33,
          name: "collectionPostalCode",
          val: "",
          t: "crm.collectionPostalCode",
          required: false,
          input: true,
          isShowInCreat: true,
        }, //[22]
        {
          id: 34,
          name: "collectionPlace",
          val: "",
          t: "crm.collectionPlace",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 32,
          name: "collectionStreet",
          val: "",
          t: "crm.collectionStreet",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 35,
          name: "collectionCountryCode",
          val: "",
          t: "crm.collectionCountryCode",
          required: false,
          items: "allCountries",
          countries: true,
          isShowInCreat: true,
        },

        // DELIVERY ADDRESS
        {
          id: 104,
          name: "delivery",
          val: "",
          t: "crm.delivery",
          divider: true,
          isShowInCreat: true,
        },

        {
          id: 211,
          name: "deliveryName",
          val: "",
          t: "crm.deliveryName",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 29,
          name: "deliveryPostalCode",
          val: "",
          t: "crm.deliveryPostalCode",
          required: false,
          input: true,
          isShowInCreat: true,
        }, //[27]
        {
          id: 30,
          name: "deliveryPlace",
          val: "",
          t: "crm.deliveryPlace",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 28,
          name: "deliveryStreet",
          val: "",
          t: "crm.deliveryStreet",
          required: false,
          input: true,
          isShowInCreat: true,
        },
        {
          id: 31,
          name: "deliveryCountryCode",
          val: "",
          t: "crm.deliveryCountryCode",
          required: false,
          items: "allCountries",
          countries: true,
          isShowInCreat: true,
        },

        {
          id: 101,
          name: "additionalInformation",
          val: "",
          t: "crm.additionalInformation",
          divider: true,
          isShowInCreat: true,
        },
        {
          id: 36,
          name: "senderInstructions",
          val: "",
          t: "crm.senderInstructions",
          required: false,
          textarea: true,
          isShowInCreat: true,
        },
        {
          id: 81,
          name: "licensePlateNumberList",
          val: "",
          t: "crm.licensePlateNumberList",
          required: false,
          input: true,
          isShowInCreat: false,
        },
        {
          id: 37,
          name: "franco",
          val: "",
          t: "crm.franco",
          required: false,
          checkbox: true,
          isShowInCreat: true,
        },
        {
          id: 38,
          name: "carrierReservations",
          val: "",
          t: "crm.carrierReservations",
          required: false,
          textarea: true,
          isShowInCreat: true,
        },
        {
          id: 39,
          name: "specialAgreements",
          val: "",
          t: "crm.specialAgreements",
          required: false,
          textarea: true,
          isShowInCreat: true,
        },
        {
          id: 40,
          name: "drawnUpPlace",
          val: "",
          t: "crm.drawnUpPlace",
          required: false,
          input: true,
          isShowInCreat: true,
        },

        {
          id: 41,
          name: "drawnUpDate",
          val: "",
          t: "crm.drawnUpDate",
          required: false,
          isTime: true,
          isShowInCreat: true,
          calendar: false,
        },
        {
          id: 42,
          name: "attachedDocuments",
          val: "",
          t: "crm.attachedDocuments",
          required: false,
          input: true,
          isShowInCreat: false,
        },
        {
          id: 43,
          name: "transportType",
          val: "",
          t: "crm.transportType",
          required: false,
          input: true,
          isShowInCreat: false,
        },

        // index 53
        {
          id: 45,
          name: "collectionDate",
          val: "",
          t: "crm.collectionDate",
          required: false,
          isTime: true,
          isShowInCreat: true,
        }, //[40]
        {
          id: 46,
          name: "deliveryDate",
          val: "",
          t: "crm.deliveryDate",
          required: false,
          isTime: true,
          isShowInCreat: true,
        },
        {
          id: 47,
          name: "receptionExpectedTime",
          val: "",
          t: "crm.receptionExpectedTime",
          required: false,
          isTime: true,
          isShowInCreat: true,
        },
        {
          id: 48,
          name: "estimatedDeliveryTime",
          val: "",
          t: "crm.estimatedDeliveryTime",
          required: false,
          isTime: true,
          isShowInCreat: true,
        },

        {
          id: 54,
          name: "successiveCarriersList",
          val: "",
          t: "crm.successiveCarriersList",
          required: false,
          input: true,
          disabled: true,
          isShowInCreat: false,
        },
        {
          id: 212,
          name: "cashOnDelivery",
          val: "",
          t: "crm.cashOnDelivery",
          required: false,
          input: true,
          disabled: false,
          isShowInCreat: true,
          maxLength: 200,
        },

        { id: 115, dividerLow: true, isShowInCreat: false },

        {
          id: 76,
          name: "excessReceptionValue",
          val: "",
          valBool: "",
          t: "crm.excessReceptionValue",
          required: false,
          checkboxValue: true,
          isShowInCreat: false,
        },
        {
          id: 77,
          name: "excessDeliveryValue",
          val: "",
          valBool: "",
          t: "crm.excessDeliveryValue",
          required: false,
          checkboxValue: true,
          isShowInCreat: false,
        },

        {
          id: 119,
          name: "attachedEmails",
          val: "",
          t: "crm.attachedEmails",
          divider: true,
          isShowInCreat: true,
        },

        {
          id: 50,
          name: "senderEmail",
          val: "",
          t: "crm.senderEmail",
          required: false,
          email: true,
          isShowInCreat: true,
        },
        {
          id: 51,
          name: "carrierEmail",
          val: "",
          t: "crm.carrierEmail",
          required: false,
          email: true,
          isShowInCreat: true,
        },
        {
          id: 52,
          name: "receiverEmail",
          val: "",
          t: "crm.receiverEmail",
          required: false,
          email: true,
          isShowInCreat: true,
        },
        {
          id: 53,
          name: "driverEmail",
          val: "",
          t: "crm.driverEmail",
          required: false,
          email: true,
          isShowInCreat: true,
        },

        { id: 108, dividerLow: true, isShowInCreat: false },

        {
          id: 69,
          name: "escalateCommentSenderEmail",
          val: "",
          t: "crm.escalateCommentSenderEmail",
          required: false,
          input: true,
          isShowInCreat: false,
        },
        {
          id: 70,
          name: "escalateCommentCarrierEmail",
          val: "",
          t: "crm.escalateCommentCarrierEmail",
          required: false,
          input: true,
          isShowInCreat: false,
        },
        {
          id: 71,
          name: "escalateCommentRecipientEmail",
          val: "",
          t: "crm.escalateCommentRecipientEmail",
          required: false,
          input: true,
          isShowInCreat: false,
        },

        { id: 109, dividerLow: true, isShowInCreat: false },

        {
          id: 73,
          name: "senderSupportEmail",
          val: "",
          t: "crm.senderSupportEmail",
          required: false,
          input: true,
          isShowInCreat: false,
        },
        {
          id: 74,
          name: "carrierSupportEmail",
          val: "",
          t: "crm.carrierSupportEmail",
          required: false,
          input: true,
          isShowInCreat: false,
        },
        {
          id: 75,
          name: "recipientSupportEmail",
          val: "",
          t: "crm.recipientSupportEmail",
          required: false,
          input: true,
          isShowInCreat: false,
        }, //[60]

        { id: 110, dividerLow: true, isShowInCreat: false },

        {
          id: 84,
          name: "photoMailingSign",
          val: "",
          t: "crm.photoMailingSign",
          required: false,
          items: "allPhotoMailingSign",
          select: true,
          isShowInCreat: true,
        },

        {
          id: 111,
          name: "comments",
          val: "",
          t: "crm.comments",
          divider: true,
          isShowInCreat: false,
        },

        {
          id: 55,
          name: "carrierComments",
          val: "",
          t: "crm.carrierComments",
          required: false,
          text: true,
          isShowInCreat: false,
        }, // [64]
        {
          id: 65,
          name: "senderComment",
          val: "",
          t: "crm.senderComment",
          required: false,
          text: true,
          isShowInCreat: false,
        }, // [65]
        {
          id: 66,
          name: "recipientComment",
          val: "",
          t: "crm.recipientComment",
          required: false,
          text: true,
          isShowInCreat: false,
        }, // [66]
        {
          id: 67,
          name: "driverComment",
          val: "",
          t: "crm.driverComment",
          required: false,
          text: true,
          isShowInCreat: false,
        }, // [67]

        {
          id: 112,
          name: "signatures",
          val: "",
          t: "crm.signatures",
          divider: true,
          isShowInCreat: false,
        },

        {
          id: 78,
          name: "senderSignatureSign",
          val: "",
          t: "crm.senderSignatureSign",
          required: false,
          items: "allSignatureSign",
          select: true,
          disabled: true,
          isShowInCreat: false,
        },
        {
          id: 160,
          name: "senderSignMethod",
          val: "",
          t: "crm.senderSignMethod",
          isSignatureMethod: true,
          isShowInCreat: false,
        },
        {
          id: 59,
          name: "senderName",
          val: "",
          t: "crm.senderName",
          required: false,
          text: true,
          isShowInCreat: false,
        },
        {
          id: 56,
          name: "signatureShipperDateTime",
          val: "",
          t: "crm.signatureShipperDateTime",
          required: false,
          text: true,
          dateFormat: true,
          isShowInCreat: false,
        },
        {
          id: 62,
          name: "senderSignature",
          val: "",
          t: "crm.senderSignature",
          required: false,
          img: true,
          isShowInCreat: false,
        },

        { id: 113, dividerLow: true, isShowInCreat: false },

        {
          id: 79,
          name: "driverSignatureSign",
          val: "",
          t: "crm.driverSignatureSign",
          required: false,
          items: "allSignatureSignDriver",
          select: true,
          disabled: true,
          isShowInCreat: false,
        },
        {
          id: 161,
          name: "driverSignMethod",
          val: "",
          t: "crm.driverSignMethod",
          isSignatureMethod: true,
          isShowInCreat: false,
        },
        {
          id: 61,
          name: "driverName",
          val: "",
          t: "crm.driverName",
          required: false,
          text: true,
          isShowInCreat: false,
        },
        {
          id: 57,
          name: "signatureDriverDateTime",
          val: "",
          t: "crm.signatureDriverDateTime",
          required: false,
          text: true,
          dateFormat: true,
          isShowInCreat: false,
        },
        {
          id: 64,
          name: "driverSignature",
          val: "",
          t: "crm.driverSignature",
          required: false,
          img: true,
          isShowInCreat: false,
        },

        { id: 114, dividerLow: true, isShowInCreat: false },

        {
          id: 80,
          name: "recipientSignatureSign",
          val: "",
          t: "crm.recipientSignatureSign",
          required: false,
          items: "allSignatureSign",
          select: true,
          disabled: true,
          isShowInCreat: false,
        },
        {
          id: 162,
          name: "recipientSignMethod",
          val: "",
          t: "crm.recipientSignMethod",
          isSignatureMethod: true,
          isShowInCreat: false,
        },
        {
          id: 60,
          name: "recipientName",
          val: "",
          t: "crm.recipientName",
          required: false,
          text: true,
          isShowInCreat: false,
        },
        {
          id: 58,
          name: "signatureReceiverDateTime",
          val: "",
          t: "crm.signatureReceiverDateTime",
          required: false,
          text: true,
          dateFormat: true,
          isShowInCreat: false,
        },
        {
          id: 63,
          name: "recipientSignature",
          val: "",
          t: "crm.recipientSignature",
          required: false,
          img: true,
          isShowInCreat: false,
        },
      ],
      allOrganizations: [],
      allDrivers: [],
      windowWidth: window.innerWidth,
      navTrigger: false,
      allTypes: [
        { id: 1, name: "CMR/AVC" },
        { id: 2, name: "CMR" },
        { id: 3, name: "AVC" },
      ],
      allCountries: [],
      organizationId: 0,
      subcontractorOrganizationsID: null,
      dialogTable: false,
      dialogTableGoods: false,
      dialogTableContainers: false,
      forceUpdateKey: 0,
      localDataFromModals: {
        // used only for create (not edit)
        goods: [],
        returnedGoods: [],
        containers: [],
        pallets: [],
      },
    };
  },
  computed: {
    navigateList() {
      const editMode = Boolean(this.$props.editCrmId);
      const list = [
        { id: 0, name: "crm.cmr", href: "#cmr" }, // both
        { id: 7, name: "crm.goods", href: "#goods" }, // edit
        { id: 8, name: "crm.returned_goods", href: "#returnedGoods" }, // edit
        { id: 9, name: "crm.containers", href: "#containers" }, // edit
        {
          id: 10,
          name: "crm.deposeContainerAddress",
          href: "#deposeContainerAddress",
        }, // both
        {
          id: 11,
          name: "crm.pickupContainerAddress",
          href: "#pickupContainerAddress",
        }, // both
        { id: 5, name: "crm.collection", href: "#collection" }, // both
        { id: 4, name: "crm.delivery", href: "#delivery" }, // both
        {
          id: 1,
          name: "crm.additionalInformation",
          href: "#additionalInformation",
        }, // both
        { id: 2, name: "crm.attachedEmails", href: "#attachedEmails" }, // both
      ];
      if (editMode) {
        list.push(
          { id: 3, name: "crm.comments", href: "#comments" },
          { id: 6, name: "crm.signatures", href: "#signatures" }
        );
      }
      return list;
    },
    cmrCodeFinalValue() {
      return {
        collectionCountryCode:
          this.filtredFields.find((field) => field.id === 35)?.val || "",

        senderOrganization: (
          this.filtredFields.find((field) => field.id === 5)
            ?.senderOrganizationName || ""
        )
          .slice(0, 3)
          .toUpperCase(),

        cmrCode: this.filtredFields.find((field) => field.id === 8)?.val || "",

        providerName: "VAE",

        getValue() {
          return this.cmrCode;
        },
      };
    },
    allCustomerCompanySign() {
      return [
        { id: 1, name: this.$i18n.t("crm.sender") },
        { id: 2, name: this.$i18n.t("crm.carrier") },
        { id: 3, name: this.$i18n.t("crm.recipient") },
      ];
    },
    allPhotoMailingSign() {
      return [
        {
          id: 0,
          text: this.$i18n.t("crm.allPhotoMailingSignTrue"),
          value: true,
        },
        {
          id: 1,
          text: this.$i18n.t("crm.allPhotoMailingSignFalse"),
          value: false,
        },
      ];
    },
    allSignatureSign() {
      return [
        { id: 0, text: this.$i18n.t("crm.allSignatureSign1"), value: 1 },
        { id: 1, text: this.$i18n.t("crm.allSignatureSign2"), value: 2 },
        { id: 2, text: this.$i18n.t("crm.allSignatureSign3"), value: 3 },
        { id: 3, text: this.$i18n.t("crm.allSignatureSign7"), value: 4 },
        { id: 4, text: this.$i18n.t("crm.allSignatureSign5"), value: 5 },
        { id: 5, text: this.$i18n.t("crm.allSignatureSign6"), value: 6 },
        { id: 6, text: this.$i18n.t("crm.allSignatureSign8"), value: 7 },
        { id: 7, text: this.$i18n.t("crm.allSignatureSign9"), value: 8 },
        { id: 8, text: this.$i18n.t("crm.allSignatureSign10"), value: 9 },
        { id: 9, text: this.$i18n.t("crm.allSignatureSign11"), value: 10 },
      ];
    },
    allSignatureSignDriver() {
      return [
        { id: 0, text: this.$i18n.t("crm.allSignatureSign1"), value: 1 },
        { id: 1, text: this.$i18n.t("crm.allSignatureSign2"), value: 2 },
        { id: 2, text: this.$i18n.t("crm.allSignatureSign3"), value: 3 },
        { id: 3, text: this.$i18n.t("crm.allSignatureSign4"), value: 4 },
        { id: 4, text: this.$i18n.t("crm.allSignatureSign5"), value: 5 },
        { id: 5, text: this.$i18n.t("crm.allSignatureSign6"), value: 6 },
        { id: 6, text: this.$i18n.t("crm.allSignatureSign8"), value: 7 },
        { id: 7, text: this.$i18n.t("crm.allSignatureSign9"), value: 8 },
        { id: 8, text: this.$i18n.t("crm.allSignatureSign10"), value: 9 },
        { id: 9, text: this.$i18n.t("crm.allSignatureSign11"), value: 10 },
      ];
    },
    allStatus() {
      return [
        { id: 0, text: this.$i18n.t("crm.allStatus1"), value: 1 },
        { id: 1, text: this.$i18n.t("crm.allStatus2"), value: 2 },
        { id: 2, text: this.$i18n.t("crm.allStatus3"), value: 3 },
        { id: 3, text: this.$i18n.t("crm.allStatus4"), value: 4 },
        { id: 4, text: this.$i18n.t("crm.allStatus5"), value: 5 },
        { id: 5, text: this.$i18n.t("crm.allStatus6"), value: 6 },
        { id: 6, text: this.$i18n.t("crm.allStatus7"), value: 7 },
        { id: 7, text: this.$i18n.t("crm.allStatus8"), value: 8 },
      ];
    },

    filtredFields() {
      let arr = [];
      switch (this.cmrStatus) {
        case 1: {
          arr = [
            112,
            78,
            59,
            56,
            62,
            113,
            79,
            61,
            57,
            64,
            114,
            80,
            60,
            58,
            63,
            160,
            161,
            162,
          ];
          break;
        }
        case 2: {
          arr = [56, 57, 58, 160, 161, 162];
          break;
        }
        case 3: {
          arr = [57, 58, 161, 162];
          break;
        }
        case 4: {
          arr = [58, 162];
          break;
        }
        default: {
          arr = [];
        }
      }
      return !arr.length
        ? this.editFields
        : this.editFields.filter((el) => !arr.includes(el.id));
    },
  },
  watch: {
    editDialog(v) {
      if (v === true) {
        this.setDefaultCrm();
        this.loadCrmData();

        if (!this.isReadOnly) {
          this.ensureTopOrganizationsLoaded("senderOrganizationsID");
          this.ensureTopOrganizationsLoaded("carrierOrganizationsID");
          this.ensureTopOrganizationsLoaded("recipientOrganizationsID");
        }
      }
    },
    windowWidth(val) {
      if (val >= 600) this.navTrigger = true;
    },
    organizationId() {
      this.getAllDrivers();
    },
    subcontractorOrganizationsID() {
      this.getAllDrivers();
    },
  },
  methods: {
    orgNoFilter() {
      return true;
    },
    isOrgField(item) {
      return (
        item &&
        [
          "senderOrganizationsID",
          "carrierOrganizationsID",
          "recipientOrganizationsID",
        ].includes(item.name)
      );
    },
    getOrgItems(fieldName) {
      return this.orgItemsByField[fieldName] || [];
    },
    getOrgLoading(fieldName) {
      return !!this.orgLoadingByField[fieldName];
    },
    ensureTopOrganizationsLoaded(field) {
      if (!field) return Promise.resolve([]);

      if (this.orgTopLoadedByField[field]) {
        this.orgItemsByField[field] = this.orgTopByField[field] || [];
        return Promise.resolve(this.orgItemsByField[field]);
      }

      this.orgLoadingByField[field] = true;

      return Axios.get(config.apiBaseUrl + "api/organization/box-list", {
        params: { search: "" },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      })
        .then((r) => {
          const items = r.data || [];
          this.orgTopByField[field] = items;
          this.orgItemsByField[field] = items;
          this.orgTopLoadedByField[field] = true;

          const cache = this.orgCacheByField[field];
          if (cache) cache[""] = items;

          return items;
        })
        .finally(() => {
          this.orgLoadingByField[field] = false;
        });
    },

    fetchOrganizations(field, q) {
      if (!field) return Promise.resolve([]);

      const query = (q || "").trim();
      const cache = this.orgCacheByField[field];

      if (cache && cache[query]) {
        this.orgItemsByField[field] = cache[query];
        return Promise.resolve(cache[query]);
      }

      this.orgLoadingByField[field] = true;

      return Axios.get(config.apiBaseUrl + "api/organization/box-list", {
        params: { search: query },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      })
        .then((r) => {
          const items = r.data || [];
          this.orgItemsByField[field] = items;
          if (cache) cache[query] = items;
          return items;
        })
        .finally(() => {
          this.orgLoadingByField[field] = false;
        });
    },

    onOrgOpen(fieldName) {
      const q = (this.orgSearch[fieldName] || "").trim();

      if (!q) {
        this.orgLoadingByField[fieldName] = true;
        return this.ensureTopOrganizationsLoaded(fieldName)
          .then((items) => {
            this.orgItemsByField[fieldName] = items;
            return items;
          })
          .finally(() => {
            this.orgLoadingByField[fieldName] = false;
          });
      }

      if (q.length >= 2) {
        this.orgLoadingByField[fieldName] = true;
        return this.fetchOrganizations(fieldName, q)
          .then((items) => {
            this.orgItemsByField[fieldName] = items;
            return items;
          })
          .finally(() => {
            this.orgLoadingByField[fieldName] = false;
          });
      }

      this.orgItemsByField[fieldName] = this.orgTopByField[fieldName] || [];
      return Promise.resolve(this.orgItemsByField[fieldName]);
    },

    onOrgClear(fieldName) {
      this.orgSearch[fieldName] = "";

      clearTimeout(this.orgDebounceTimer[fieldName]);
      this.orgDebounceTimer[fieldName] = null;

      return this.onOrgOpen(fieldName);
    },

    onOrgSearchInput(fieldName, val) {
      const q = (val || "").trim();
      this.orgSearch[fieldName] = val;

      clearTimeout(this.orgDebounceTimer[fieldName]);

      if (!q) {
        this.onOrgOpen(fieldName);
        return;
      }

      if (q.length < 2) {
        this.orgItemsByField[fieldName] = this.orgTopByField[fieldName] || [];
        return;
      }

      this.orgDebounceTimer[fieldName] = setTimeout(() => {
        this.orgLoadingByField[fieldName] = true;

        this.fetchOrganizations(fieldName, q)
          .then((items) => {
            this.orgItemsByField[fieldName] = items;
          })
          .finally(() => {
            this.orgLoadingByField[fieldName] = false;
          });
      }, 300);
    },

    ensureSelectedOrgVisible(field, orgId, orgName) {
      if (!orgId) return Promise.resolve();

      const existsNow = (this.orgItemsByField[field] || []).some(
        (x) => Number(x.id) === Number(orgId)
      );
      if (existsNow) return Promise.resolve();

      const q = (orgName || "").trim();

      const selectedStub = { id: Number(orgId), name: q || String(orgId) };
      this.orgItemsByField[field] = [
        selectedStub,
        ...(this.orgItemsByField[field] || []),
      ];

      if (!q || q.length < 2) {
        return this.ensureTopOrganizationsLoaded(field).then(() => {
          const ok = (this.orgItemsByField[field] || []).some(
            (x) => Number(x.id) === Number(orgId)
          );
          if (!ok)
            this.orgItemsByField[field] = [
              selectedStub,
              ...this.orgItemsByField[field],
            ];
        });
      }

      return this.fetchOrganizations(field, q).then(() => {
        const ok = (this.orgItemsByField[field] || []).some(
          (x) => Number(x.id) === Number(orgId)
        );
        if (!ok)
          this.orgItemsByField[field] = [
            selectedStub,
            ...this.orgItemsByField[field],
          ];
      });
    },

    findOrgById(id) {
      const nid = Number(id);
      if (!nid) return null;

      const keys = [
        "senderOrganizationsID",
        "carrierOrganizationsID",
        "recipientOrganizationsID",
      ];

      for (const k of keys) {
        const arr = this.orgItemsByField[k] || [];
        const found = arr.find((x) => Number(x.id) === nid);
        if (found) return found;
      }

      for (const k of keys) {
        const arr = this.orgTopByField[k] || [];
        const found = arr.find((x) => Number(x.id) === nid);
        if (found) return found;
      }

      for (const k of keys) {
        const cache = this.orgCacheByField[k];
        if (!cache) continue;

        for (const q in cache) {
          const arr = cache[q] || [];
          const found = arr.find((x) => Number(x.id) === nid);
          if (found) return found;
        }
      }

      return null;
    },

    onChangeSideEffects(value, name) {
      if (!this.editCrmId && name === "collectionPlace") {
        const collectionStreet = this.editFields.find(
          (item) => item.name === "drawnUpPlace"
        );
        collectionStreet.val = collectionStreet.val || value;
      }
    },
    resetEditCmr(snackbar = null) {
      this.cmrStatus = "";
      this.closeDialog(snackbar);
    },
    saveCmr() {
      const { dateFormatToDb, editCrmId } = this;
      const url = editCrmId
        ? config.apiBaseUrl + "api/cmr/edit"
        : config.apiBaseUrl + "api/cmr/create";
      const text = editCrmId
        ? this.$i18n.t("crm.updated")
        : this.$i18n.t("crm.created");
      const {
        collectionCountryCode,
        senderOrganization,
        cmrCode,
        providerName,
      } = this.cmrCodeFinalValue;
      let data = Object.fromEntries(
        this.editFields.map((el) => {
          if (el.name === "cmrCode" && !editCrmId) {
            const val = `${collectionCountryCode}${senderOrganization}${cmrCode}${providerName}`;
            return [el.name, val];
          }
          if (el.isTime && el.val !== "") {
            return [el.name, dateFormatToDb(el.val)];
          }
          if (
            [
              "senderEmail",
              "carrierEmail",
              "receiverEmail",
              "driverEmail",
            ].includes(el.name)
          ) {
            return [el.name, el.val || "empty"];
          }
          return [el.name, el.val];
        })
      );

      delete data.cmr;

      if (editCrmId) {
        data.id = editCrmId;
      }

      if (!editCrmId) {
        Object.keys(this.localDataFromModals).forEach((key) => {
          data[key] = this.localDataFromModals[key].map((item) => {
            delete item.id;
            return item;
          });
        });
        data = cleanObject(data);
      }

      Axios.post(url, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.resetEditCmr({ isShow: true, text: text });
            this.reloadCmr();
          }
        })
        .catch(function(error) {
          /* eslint-disable */
          console.error(error);
          alert(error.response.data);
        });
    },
    closeDatePicker(i) {
      this.editFields[i].calendar = false;
    },
    cancelDatePicker(i) {
      this.editFields[i].val = this.cmr[this.editFields[i].name];
      this.editFields[i].calendar = false;
    },
    cmrCode(value, disabled) {
      return (
        disabled ||
        (value && !isNaN(+value) && value.length <= 20 && value.length >= 6) ||
        this.$i18n.t("crm.onlyDigits")
      );
    },

    /*required(required) {
      if (!required) return () => true;
      return function (v) {
        return !!v || this.$i18n.t("user.required");
      };
    },*/

    required(required) {
      if (!required) return () => true;
      return (v) => !!v || this.$i18n.t("user.required");
    },

    /*required(isRequired) {
      return (value) => isRequired && !value && this.$i18n.t("user.required");
    },*/

    loadCrmData() {
      const $this = this;

      if (this.editCrmId) {
        Axios.get(config.apiBaseUrl + "api/cmr/item?cmr_id=" + this.editCrmId, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then(async (response) => {
            if (response.status === 200) {
              const data = response.data;

              $this.cmr = Object.assign({}, data);
              $this.cmrStatus = $this.cmr.status;

              $this.editFields = $this.editFields.map((el) => {
                el.val = data[el.name];

                switch (el.name) {
                  case "senderEmail":
                    el.disabled =
                      $this.cmrStatus >= CMR_STATUSES.SignatureShipper;
                    break;
                  case "carrierEmail":
                  case "driverEmail":
                    el.disabled =
                      $this.cmrStatus >= CMR_STATUSES.SignatureDriver;
                    break;
                  case "receiverEmail":
                  case "licenseplateTruckPDF":
                  case "licenseplateTrailerPDF":
                    el.disabled =
                      $this.cmrStatus >= CMR_STATUSES.SignatureReceiver;
                    break;
                  default:
                    break;
                }

                if (el.isTime && el.val !== "" && el.val !== null) {
                  const arr = el.val.split("T");
                  if (arr.length > 1) {
                    if (el.id === 41) {
                      el.val = arr[0];
                    } else {
                      el.val = $this.dateFormatToUi(el.val);
                    }
                  }
                }

                if ((el.isTime && el.val === "") || el.val === null) {
                  if ($this.$refs[el.name]) {
                    $this.$refs[el.name][0].clearHandler();
                  }
                }

                // READ ONLY: show as input text
                if (
                  (el.id === 5 || el.id === 7 || el.id === 6) &&
                  $this.isReadOnly
                ) {
                  el.input = true;
                  delete el.autocomplete;

                  if (el.id === 5) {
                    el.name = "senderOrganizationName";
                    el.val = data.senderStreet
                      ? `${data[el.name]}, ${data.senderStreet}`
                      : `${data[el.name]}`;
                  }
                  if (el.id === 7) {
                    el.name = "carrierOrganizationName";
                    el.val = data.carrierStreet
                      ? `${data[el.name]}, ${data.carrierStreet}`
                      : `${data[el.name]}`;
                  }
                  if (el.id === 6) {
                    el.name = "recipientOrganizationName";
                    el.val = data.recipientStreet
                      ? `${data[el.name]}, ${data.recipientStreet}`
                      : `${data[el.name]}`;
                  }
                }

                // EDIT MODE: use v-autocomplete with IDs
                if (
                  (el.id === 5 || el.id === 6 || el.id === 7) &&
                  !$this.isReadOnly
                ) {
                  el.autocomplete = true;
                  delete el.input;

                  if (el.id === 5) el.name = "senderOrganizationsID";
                  if (el.id === 7) el.name = "carrierOrganizationsID";
                  if (el.id === 6) el.name = "recipientOrganizationsID";

                  el.val = data[el.name];
                }

                return el;
              });

              $this.organizationId = data.carrierOrganizationsID;
              $this.subcontractorOrganizationsID =
                data.subcontractorOrganizationsID;

              if (
                $this.editFields[76].val === "" &&
                $this.editFields[77].val === "" &&
                $this.editFields[78].val === "" &&
                $this.editFields[79].val === ""
              ) {
                $this.editFields[76].val = "No comments";
              }

              if (!$this.isReadOnly) {
                try {
                  await Promise.all([
                    $this.ensureTopOrganizationsLoaded("senderOrganizationsID"),
                    $this.ensureTopOrganizationsLoaded(
                      "carrierOrganizationsID"
                    ),
                    $this.ensureTopOrganizationsLoaded(
                      "recipientOrganizationsID"
                    ),
                  ]);

                  await Promise.all([
                    $this.ensureSelectedOrgVisible(
                      "senderOrganizationsID",
                      data.senderOrganizationsID,
                      data.senderOrganizationName
                    ),
                    $this.ensureSelectedOrgVisible(
                      "carrierOrganizationsID",
                      data.carrierOrganizationsID,
                      data.carrierOrganizationName
                    ),
                    $this.ensureSelectedOrgVisible(
                      "recipientOrganizationsID",
                      data.recipientOrganizationsID,
                      data.recipientOrganizationName
                    ),
                  ]);
                } catch (e) {
                  // eslint-disable-next-line no-console
                  console.error("ensureSelectedOrgVisible failed", e);
                }
              }
            }
          })
          .catch(function(error) {
            /* eslint-disable */
            console.error(error);
            alert(error.response.data);
          });
      } else {
        this.forceUpdateKey += 1;
      }
    },

    setDefaultCrm() {
      this.editFields = this.editFields.map((el) => {
        el.val = this.defaultCmr[el.name];
        return el;
      });
    },

    getAllDrivers() {
      let $this = this;
      let payload = Object.assign({}, this.payload);
      payload.Limit = 10000;
      payload.password = this.passwordNew;

      let organization = $this.subcontractorOrganizationsID
        ? $this.subcontractorOrganizationsID
        : $this.organizationId;

      let path = "api/employee/driver-list?organization_id=" + organization;

      Axios.get(config.apiBaseUrl + path, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            $this.allDrivers = response.data.map((el) => {
              return { id: el.userName, name: el.userName };
            });
          }
        })
        .catch(function(error) {
          /* eslint-disable */
          console.error(error);
          alert(error.response.data);
        });
    },
    getInputProps(item) {
      return {
        prependIcon: "mdi-calendar-month",
        readonly: true,
        required: "item.required",
        rules: [this.required(item.required)],
        outlined: true,
      };
    },
    getDateProps() {
      return {
        locale: this.$i18n.locale,
        color: "#5b8ff5",
      };
    },
    getTimeProps() {
      return {
        format: "24hr",
        color: "#5b8ff5",
      };
    },
    getList(str) {
      return this[str];
    },
    getAllCuontries() {
      const $this = this;
      Axios.get(config.apiBaseUrl + "api/organization/country-list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            $this.allCountries = response.data;
          }
        })
        .catch(function(error) {});
    },
    signatureImg(src) {
      if (!src) return false;
      return `data:image/png;base64,${src}`;
    },

    setOrganizationId(id, addEvent) {
      if (addEvent) {
        this.organizationId = id;
      }
    },

    handlerOrganization(id, item) {
      this.setOrganizationId(id, item.addEvent);

      // Автозаполнение адресов делаем только при создании
      if (this.editCrmId) return;

      const org = this.findOrgById(id);
      if (!org) return;

      const elZip = org.postalCode || "";
      const elPlace = org.place || "";
      const elStreet = org.street || "";
      const elCountry = org.countryCode || "";
      const elSender = org.name || "";

      const setFieldValue = (fieldName, value) => {
        const field = this.editFields.find((x) => x.name === fieldName);
        if (field) field.val = value;
      };

      const cmrCodeField = this.editFields.find((x) => x.name === "cmrCode");
      if (cmrCodeField && item.name === "senderOrganizationsID") {
        cmrCodeField.senderOrganizationName = elSender;
      }

      switch (item.name) {
        case "senderOrganizationsID": {
          const senderField = this.editFields.find((field) => field.id === 5);

          if (senderField) {
            senderField.senderOrganizationName = elSender;
          }

          setFieldValue("collectionName", elSender);
          setFieldValue("collectionPostalCode", elZip);
          setFieldValue("collectionPlace", elPlace);
          setFieldValue("collectionStreet", elStreet);
          setFieldValue("collectionCountryCode", elCountry);
          break;
        }

        case "recipientOrganizationsID":
          setFieldValue("deliveryName", elSender);
          setFieldValue("deliveryPostalCode", elZip);
          setFieldValue("deliveryPlace", elPlace);
          setFieldValue("deliveryStreet", elStreet);
          setFieldValue("deliveryCountryCode", elCountry);
          break;

        default:
          break;
      }
    },

    dateFormatToUi(val) {
      return this.$utcToCurrentDate(val);
    },

    dateFormatToDb(val) {
      return this.$dateToUtc(val);
    },

    openDialogTable(type) {
      this.toggleDialogTable(type, true);
    },

    closeDialogTable(type) {
      this.toggleDialogTable(type, false);
    },
    updateFromEditModalDialog(name, value) {
      this.localDataFromModals = {
        ...this.localDataFromModals,
        [name]: value,
      };
    },

    toggleDialogTable(type, state) {
      switch (type) {
        case "pallets":
        case "returnedGoods":
          this.dialogTable = state;
          break;
        case "goods":
          this.dialogTableGoods = state;
          break;
        case "containers":
          this.dialogTableContainers = state;
          break;
        default:
          this.dialogTable = false;
          this.dialogTableGoods = false;
          this.dialogTableContainers = false;
      }
    },

    isExtraEditing(isReadOnly) {
      if (isReadOnly) return false;
      return this.cmrStatus === 3 || this.cmrStatus === 4;
    },

    isShowInCreating(isShowInCreat) {
      return this.editCrmId || isShowInCreat;
    },

    isLicensePlatePdfField(item) {
      return (
        item &&
        ["licenseplateTruckPDF", "licenseplateTrailerPDF"].includes(item.name)
      );
    },

    setDisabled(itemDisabled) {
      if (this.editCrmId) {
        return this.isReadOnly ? this.isReadOnly : itemDisabled;
      } else {
        return false;
      }
    },
    getTooltip(name) {
      switch (name) {
        case "pallets":
          return this.$i18n.t("crm.addPallets");
        case "returnedGoods":
          return this.$i18n.t("crm.addPallets");
        case "goods":
          return this.$i18n.t("crm.addGoods");
        case "containers":
          return this.$i18n.t("crm.addContainers");
        default:
          return "";
      }
    },

    //------------ end methods
  },
  created() {
    if (this.editCrmId) {
      this.loadCrmData();
    }
    if (!this.isReadOnly) {
      this.ensureTopOrganizationsLoaded("senderOrganizationsID");
      this.ensureTopOrganizationsLoaded("carrierOrganizationsID");
      this.ensureTopOrganizationsLoaded("recipientOrganizationsID");
    }
    this.getAllCuontries();
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    this.navTrigger = this.windowWidth >= 600;
  },
};
</script>
<style scoped>
.order-edit-modal__multiline-text {
  white-space: pre-line;
}
</style>
